import actionTypes from 'constants/actionTypes'
import type { ShapesAllMap } from 'types/shapes'

interface ShapesAllAction {
  type?: string
  payload?: {
    id?: string
    shapeType?: string
    entityIds?: string[]
    settings?: unknown
    layout?: boolean
  }
}

const all = (state: ShapesAllMap = {}, action: ShapesAllAction): ShapesAllMap => {
  switch (action.type) {
    case actionTypes.SHAPES.ADD: {
      const p = action.payload
      if (!p?.id) return state
      return {
        ...state,
        [p.id]: {
          id: p.id,
          shapeType: p.shapeType as 'list',
          entityIds: p.entityIds ?? [],
          settings: p.settings as ShapesAllMap[string]['settings'],
          layout: p.layout ?? true,
        },
      }
    }
    case actionTypes.SHAPES.REMOVE: {
      const id = action.payload?.id
      if (!id || !state[id]) return state
      const { [id]: _, ...rest } = state
      return rest
    }
    case actionTypes.SHAPES.UPDATE: {
      const p = action.payload
      if (!p?.id || !state[p.id]) return state
      const existing = state[p.id]!
      const updated: typeof existing = {
        ...existing,
        ...(p.entityIds !== undefined && { entityIds: p.entityIds }),
        ...(p.settings !== undefined && { settings: p.settings as typeof existing.settings }),
        ...(p.layout !== undefined && { layout: p.layout }),
      }
      return { ...state, [p.id]: updated }
    }
    default:
      return state
  }
}

export default all
